import { useContext } from "react";
import PropTypes from "prop-types";
import FaqHomeCategory from "app/pages/Faq/FaqHome/FaqHomeCategories/FaqHomeCategory";
import "./FaqHomeCategories.scss";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import FaqCategoriesSlider from "app/pages/Faq/FaqHome/FaqHomeCategories/FaqCategoriesSlider";

const FaqHomeCategories = ({ categories }) => {
	const { resolution } = useContext(AppGlobalsContext);

	const isDesktop = resolution === RESOLUTION.LARGE || resolution === RESOLUTION.XLARGE;

	return (
		<div className="faq-home-categories">
			{!isDesktop ? (
				categories?.map(category => {
					return (
						<div key={category.id} className="faq-home-categories__item">
							<FaqHomeCategory
								categoryName={category.name}
								categoryId={category.id}
								subCategories={category.subCategories}
								categoryPicture={category.image}
							/>
						</div>
					);
				})
			) : (
				<div className="faq-home-categories__carousel">
					<FaqCategoriesSlider categories={categories} />
				</div>
			)}
		</div>
	);
};

FaqHomeCategories.propTypes = {
	categories: PropTypes.array,
};

FaqHomeCategories.defaultProps = {
	categories: [],
};

export default FaqHomeCategories;
